import {Typography} from "@material-ui/core";
import React from "react";

const FormContainer = ({children, classes, title, width}) => (
    <div className="page-container">
        <div style={{width: width}}>
            {title ? <div className="page-description">
                <Typography color="primary" gutterBottom variant="h5" component="h2">
                    {title}
                </Typography>
            </div> : null}
            {children}
        </div>
    </div>
);

export default FormContainer;